module.exports = "<div class=story-info> <h4> <a v-link=\"{ name: 'read-chapter', params: { story: story.id, chapter: 1} }\">{{ story.title }}</a> <a v-if=\"story.chapters > 1\" v-link=\"{ name: 'read-chapter', params: { story: story.id, chapter: story.chapters} }\">&raquo;</a> <small> by {{ story.author }} </small> </h4> <p>{{ story.summary }}</p> <story-small-meta :story=story></story-small-meta> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StoryInfo.vue
 ** module id = 77
 ** module chunks = 0
 **/